import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | RH Routes
    |--------------------------------------------------------------------------|
    */

    path: 'rh',
    name: 'rh',
    children: [
        /*
        |--------------------------------------------------------------------------
        | Payslips Routes
        |--------------------------------------------------------------------------|
        */
        {
            path: 'payslips',
            children: [
                {
                    path: '',
                    name: 'payslips',
                    component: () => import('@/Modules/RH/views/Payslip/Index'),
                    meta: {  requiresPermission: abilities.VIEW_PAYSLIP,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
                {
                    path: ':office/create',
                    name: 'payslips-office-create',
                    component: () => import('@/Modules/RH/views/Payslip/Create'),
                    meta: {  requiresPermission: abilities.CREATE_PAYSLIP,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
                {
                    name: "payslip-file",
                    path: ":id/file" ,
                    component: () => import('@/Modules/RH/views/Payslip/File.vue'),
                    meta: {  requiresPermission: abilities.DOWNLOAD_PAYSLIP,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
            ]
        },
        {
            path: 'employe/folders',
            children: [
                {
                    path: '',
                    name: 'employe-folder-list',
                    component: () => import('@/Modules/RH/views/EmlpoyeFolder/Index.vue'),
                    meta: {  requiresPermission: abilities.VIEW_EMPLOYEE_CONTRACT,requiresAccess: [moduleAbilities.RH_CONTRACT]},
                },
                {
                    path: 'create',
                    name: 'employe-folder-list-create',
                    component: () => import('@/Modules/RH/views/EmlpoyeFolder/Create'),
                    meta: {  requiresPermission: abilities.VIEW_EMPLOYEE_CONTRACT,requiresAccess: [moduleAbilities.RH_CONTRACT]},
                },
                {
                    name: "employe-folder-list-view",
                    path: ":id/view" ,
                    component: () => import('@/Modules/RH/views/EmlpoyeFolder/View'),
                    meta: {  requiresPermission: abilities.VIEW_EMPLOYEE_CONTRACT,requiresAccess: [moduleAbilities.RH_CONTRACT]},
                },
            ]
        },
        {
            path: 'settings/payslips',
            name: 'rh-settings-payslips',
            component: () => import('@/Modules/RH/views/Setting/Layouts/BasePayslipSetting.vue'),
            children: [
                {
                    name: "rh-settings-payslips-pensions",
                    path: "pensions",
                    component: () => import('@/Modules/RH/views/Setting/pension/Index.vue'),
                    meta: {  requiresPermission: abilities.VIEW_PENSION,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
                {
                    name: "rh-settings-payslips-allowances",
                    path: "allowances",
                    component: () => import('@/Modules/RH/views/Setting/allowance/Index.vue'),
                    meta: {  requiresPermission: abilities.VIEW_ALLOWANCE,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
                {
                    name: "rh-settings-payslips-others",
                    path: "others",
                    component: () => import('@/Modules/RH/views/Setting/others/Index.vue'),
                    meta: {  requiresPermission: abilities.VIEW_OTHER,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
                {
                    name: "rh-settings-payslips-taxes",
                    path: "taxes",
                    component: () => import('@/Modules/RH/views/Setting/taxes/Index.vue'),
                    meta: {  requiresPermission: abilities.VIEW_PAYROLL_TAX,requiresAccess: [moduleAbilities.RH_PAYSLIP]},
                },
            ]
        },
        {
            path: 'settings/leaves',
            name: 'rh-settings-leaves',
            component: () => import('@/Modules/RH/views/Setting/Layouts/BaseAbsenceSetting.vue'),
            children: [
                 {
                    name: "settings-leave-openDays",
                    path: "open-days/list",
                    component: () => import('@/Modules/RH/views/Setting/IndexOpenDays.vue'),
                    meta: {requiresPermission: abilities.VIEW_POST_OFFICE},
                },
                {
                    name: "settings-leave-publicHolidayList",
                    path: "public-holiday/list",
                    component: () => import('@/Modules/RH/views/Setting/IndexPublicHoliday.vue'),
                    meta: {requiresPermission: abilities.VIEW_POST_OFFICE},
                },
                {
                    name: "settings-leave-holidayTypeList",
                    path: "holiday-type/list",
                    component: () => import('@/Modules/RH/views/Setting/IndexHolidayType.vue'),
                    meta: {requiresPermission: abilities.VIEW_POST_OFFICE},
                },
                {
                    name: "settings-leave-create",
                    path: "create",
                    component: () => import('@/Modules/RH/views/Setting/components/CreateHolidayType.vue'),
                    meta: {requiresPermission: abilities.VIEW_POST_OFFICE},
                },
                {
                    name: "settings-leave-update",
                    path: "update/:id",
                    component: () => import('@/Modules/RH/views/Setting/components/CreateHolidayType.vue'),
                    meta: {requiresPermission: abilities.VIEW_POST_OFFICE},
                },
            ]
        },

        {
            name: "contracts",
            path: "contracts",
            component: () => import('@/Modules/RH/views/Contracts/Index.vue'),
            meta: {  requiresPermission: abilities.VIEW_EMPLOYEE_CONTRACT,requiresAccess: [moduleAbilities.RH_CONTRACT]},
        },

        {
            name: "user-absences",
            path: "user_absences",
            component: () => import('@/views/User/LayoutUserAccount/BaseSettingUserLayout.vue'),
            children: [
                {
                    path: '',
                    component: () => import('@/Modules/RH/views/UserAbsences/Index.vue'),
                    name: 'absences',
                    meta: {  requiresPermission: abilities.VIEW_HOLIDAY,requiresAccess: [moduleAbilities.RH_ABSENCE]},
                },
            ]
        },
        /*
        |--------------------------------------------------------------------------
        | Absences Admin Routes
        |--------------------------------------------------------------------------|
        */
        {
            path: 'absences',
            component: () => import('@/Modules/RH/views/Absences/Index.vue'),
            name: 'rh-absences',
            meta: {  requiresPermission: abilities.VIEW_HOLIDAY,requiresAccess: [moduleAbilities.RH_ABSENCE]},
        },
        {
            path: 'absence/:society/:id/view',
            component:  () => import('@/Modules/RH/views/Absences/View.vue'),
            name: 'rh-absences-view',
            meta: {  requiresPermission: abilities.VIEW_HOLIDAY,requiresAccess: [moduleAbilities.RH_ABSENCE]},
        },
    ]

}
